'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return function (next) {
    return function (action) {
      var type = action.type;


      if (type.indexOf('_FAILED') > -1) {
        _Raven2.default.captureMessage(type, {
          extra: {
            action: action
          }
        });
      }

      return next(action);
    };
  };
};

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/sentryMiddleware.js
// module id = 401
// module chunks = 3 4 5